
import { defineComponent } from "vue";
import InvoiceTemplatePreview from "@/components/invoice/InvoiceTemplatePreview.vue";

export default defineComponent({
  components: { InvoiceTemplatePreview },
});
